import axiosInstance from "../auth/FetchInterceptor";
import {
  ACTIVE_SUBSCRIPTION,
  COPY_SUBSCRIPTION,
  GET_PARTNER_SAAS,
  GET_SUBSCRIPTION_DETAIL,
  GET_SUBSCRIPTIONS_HISTORY,
  GET_SUBSCRIPTIONS_LIST,
  GET_USER_SUBSCRIPTION,
  TIME_SUBSCRIPTION,
  TIME_SUBSCRIPTION_V2,
} from "../constants/ApiConstant";

const SaasService = {}

SaasService.getSubscription = (data) => {
  return axiosInstance.post(GET_SUBSCRIPTIONS_LIST, data);
};

SaasService.getSubscriptionHistory = (data) => {
  return axiosInstance.post(GET_SUBSCRIPTIONS_HISTORY, data);
};

SaasService.getSubscriptionRegister = () => {
  return axiosInstance.get(GET_SUBSCRIPTION_DETAIL);
};

SaasService.getSubscriptionInfo = (id) => {
  return axiosInstance.get(`${GET_SUBSCRIPTION_DETAIL}/${id}`);
};

SaasService.upSetSubscription = (data) => {
  return axiosInstance.put(GET_SUBSCRIPTION_DETAIL, data);
};

SaasService.copySubscription = (data) => {
  return axiosInstance.post(COPY_SUBSCRIPTION, data);
};

SaasService.getUserSubscription = (id) => {
  return axiosInstance.get(`${GET_USER_SUBSCRIPTION}/${id}`);
};

SaasService.changeActiveUserSub = (id) => {
  return axiosInstance.put(`${GET_USER_SUBSCRIPTION}/${id}`);
};

SaasService.getPartnerSaas = () => {
  return axiosInstance.get(GET_PARTNER_SAAS);
};

SaasService.getTimeSubs = (subscriptionId) => {
  return axiosInstance.get(`${TIME_SUBSCRIPTION}/${subscriptionId}`);
};

SaasService.getTimeSubsV2 = (data) => {
  return axiosInstance.post(TIME_SUBSCRIPTION_V2, data);
};

SaasService.upSetUserSubscription = (data) => {
  return axiosInstance.post(GET_SUBSCRIPTION_DETAIL, data);
};

SaasService.activeSubscription = (data) => {
  return axiosInstance.post(ACTIVE_SUBSCRIPTION, data);
};

export default SaasService;
